import { connect } from 'react-redux'
import { State } from 'interfaces/state'
import { MoneyflowPageDispatchProps, MoneyflowPageStateProps } from 'interfaces/moneyflow'
import SpendingPage from 'components/features/pfm/SpendingPage/SpendingPage'
import internal from 'components/utils/Internal'

const mapStateToProps = (state: State): MoneyflowPageStateProps => ({
  categoryId: state.app.spending.categories.selectedId,
  timeframe: state.app.spending.timeframe,
})

const SpendingContainer = internal(connect<
  MoneyflowPageStateProps, MoneyflowPageDispatchProps
>(mapStateToProps)(SpendingPage))
export default SpendingContainer
